<template>
  <div v-if="$page" class="legal">
    <h2 class="section__title">{{ currentContent.title }}</h2>
    <RawHtml :html="currentContent.text" />
  </div>
</template>

<script>
import RawHtml from '@/components/global/RawHtml.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin.js'

export default {
  name: 'LegalText',
  beetPage: 'legal',
  mixins: [PageMetaMixin],
  components: { RawHtml },
  computed: {
    currentContent() {
      const prefix = this.$route.name.replace(/:\w\w$/, '')

      return {
        title: this.$page[`${prefix}Title`],
        text: this.$page[`${prefix}Text`],
      }
    },
  },
}
</script>
